import React, { useEffect, useState } from "react";
import { Form, InputNumber, Modal, DatePicker, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useBlanketOrderDetail } from "../../hooks/useBlanketOrderDetail";
import moment from "moment";
import { useProduct } from "../../hooks/useProduct";
// import { AccountContext } from "../layouts/BaseLayout";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const NewBlanketOrderDetailModal = (props) => {
  // const { account } = useContext(AccountContext);
  const { order, visible, setVisible, dispatch } = props;

  const { t } = useTranslation();

  const [form] = Form.useForm();

  const { create } = useBlanketOrderDetail();

  const { findAll } = useProduct();

  const [submitting, setSubmitting] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();

  useEffect(() => {
    if (visible) {
      findAll({
        companyId: order.supplierId,
      }).then((res) => {
        if (res.status === "success") {
          setProductOptions(res.data);
        }
      });
    }
  }, [visible, findAll]);

  const handleOk = (e) => {
    form.validateFields().then((values, err) => {
      if (!err) {
        const params = {
          blanketOrderId: order.id,
          productId: values.productId,
          requestShipDate: values.requestShipDate ? moment(values.requestShipDate).format() : null,
          quantityInUom: values.quantityInUom,
          uomPrice: values.uomPrice,
          uomId: selectedProduct.SaleUom.Uom.id,
          remarks: values.remarks,
        };
        setSubmitting(true);
        create(params).then((res) => {
          if (res.status === "success") {
            dispatch({ type: "refresh" });
            setSelectedProduct();
            setVisible(false);
            form.resetFields();
          }
          setSubmitting(false);
        });
      }
    });
  };

  const handleCancel = () => setVisible(false);

  const onChange = (value) => {
    const index = productOptions.map((item) => item.id).indexOf(value);

    if (index > -1) {
      setSelectedProduct(productOptions[index]);
    } else {
      setSelectedProduct();
    }
  };

  return (
    <Modal
      title={t("product.addNewTitle")}
      confirmLoading={submitting}
      centered
      visible={visible}
      destroyOnClose
      onCancel={handleCancel}
      onOk={handleOk}
      okText={t("action.submit")}
      okButtonProps={{ disabled: !selectedProduct || !selectedProduct.SaleUom }}
      cancelText={t("action.cancel")}
    >
      <Form form={form} {...layout} name="order-item-form">
        <Form.Item
          name="productId"
          label={t("common.product")}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={onChange}
          >
            {productOptions.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.productName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="requestShipDate" label={t("blanketOrder.requestShipDate")}>
          <DatePicker allowClear />
        </Form.Item>

        <Form.Item
          name="quantityInUom"
          label={t("common.quantity")}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber min={0} allowClear />
        </Form.Item>

        <Form.Item
          name="uomPrice"
          label={t("common.price")}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber min={0} allowClear />
        </Form.Item>

        <Form.Item label={t("common.uom")}>
          {selectedProduct && selectedProduct.SaleUom ? selectedProduct.SaleUom.Uom.shortCode : "-"}
        </Form.Item>

        <Form.Item name="remarks" label={t("common.remarks")}>
          <Input.TextArea rows={5} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default NewBlanketOrderDetailModal;
